import { request, language } from '@tencent/ppd-base-libs';
import dayjs from 'dayjs';
import { BannerConfig } from '../types';

/**
 * 获取banner的配置，banner配置符合指定的结构
 * @param bannerConfigUrl banner配置Url
 */
export async function getBannerConfig(bannerConfigUrl: string): Promise<BannerConfig[]> {
  const bannerData = await request.loadConfig(bannerConfigUrl);
  const lang = language.getLanguage().toLowerCase()
    .replace(/-/g, '_');
  // 格式化，处理时间和多语言
  return bannerData.map(bannerItem => ({
    ...bannerItem,
    bannerTime: {
      startTime: dayjs(bannerItem.bannerTime.startTime).toDate(),
      endTime: dayjs(bannerItem.bannerTime.endTime).toDate(),
    },
    bannerImgUrl: bannerItem.bannerImgUrl[lang],
    bannerAlt: bannerItem.bannerAlt?.[lang] ?? '',
    bannerJumpInfo: {
      jumpUrl: bannerItem.bannerJumpUrl?.[lang] ?? '',
      miniAppId: bannerItem.bannerJumpMiniApp?.appid ?? '', // TODO：通用 banner 配置加上 appid
      miniAppUsername: bannerItem.bannerJumpMiniApp?.username ?? '',
      miniAppPath: bannerItem.bannerJumpMiniApp?.path ?? '',
    },
    weight: +bannerItem.weight || 0,
    emitKey: bannerItem.emitKey ?? '',
  }));
}
